export default function ({ children }: { children: React.ReactNode }) {
  return <div className="font-sans w-full top-0">{children}</div>;
}
